import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(()=>({
        checkboxInput: {
            alignItems: 'center',
            cursor: 'default'
        },
        fullWidth: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }));
const CheckboxInput_styles = useStyles;
export default CheckboxInput_styles;
